export default __webpack_public_path__ + "static/media/enterprise-dynamic.ad6c82ec.png";